import React from 'react';
import {Link} from 'react-router-dom';
import {
    Button,
    Container,
    Divider,
    Group,
    Image,
    Paper,
    SimpleGrid,
    Stack,
    Text,
    Title,
    useMantineTheme
} from '@mantine/core';
import {useConfig} from '../ConfigContext';

/**
 * Four cards, photograph first. Each experience line is "Organisation|what they
 * did there" — the organisation carries the weight, so it is the bold half.
 */
function Leadership() {
    const theme = useMantineTheme();
    const {leadership} = useConfig();

    return (
        <Container size="xl" py="xl">
            <Stack gap={56}>
                <Stack gap="sm">
                    <Title order={1} c={theme.colors.brand[6]}>{leadership.heading}</Title>
                    <Text size="lg" maw={820}>{leadership.intro}</Text>
                </Stack>

                <SimpleGrid cols={{base: 1, sm: 2, lg: 4}} spacing="lg">
                    {leadership.people.map((person) => (
                        <Paper key={person.name} withBorder radius="lg" p="lg" shadow="sm" h="100%">
                            <Stack gap="md">
                                <Image
                                    src={person.photo}
                                    alt={person.name}
                                    w={128}
                                    h={128}
                                    radius={64}
                                    fit="cover"
                                    style={{alignSelf: 'start'}}
                                />
                                <Stack gap={2}>
                                    <Text fw={700} size="lg">{person.name}</Text>
                                    <Text fw={600} c={theme.colors.brand[6]}>{person.title}</Text>
                                </Stack>
                                <Text size="sm">{person.intro}</Text>
                                <Stack gap={6}>
                                    {person.experience.map((entry) => {
                                        const [org, what] = entry.split('|');
                                        return (
                                            <Text key={entry} size="sm" c="dimmed">
                                                <Text span fw={600} inherit>{org}</Text>
                                                {what ? ` — ${what}` : ''}
                                            </Text>
                                        );
                                    })}
                                </Stack>
                            </Stack>
                        </Paper>
                    ))}
                </SimpleGrid>

                <Divider/>

                <Stack gap="md" maw={820}>
                    <Title order={2} size="h3">Want to talk to one of us?</Title>
                    <Text>
                        There are four of us and no account managers, so whoever picks up your
                        message is the person who can actually answer it.
                    </Text>
                    <Group mt="xs">
                        <Button component={Link} to="/contact-us" radius="xl" color="brand.6">
                            Talk to us
                        </Button>
                        <Button component={Link} to="/ventures" radius="xl" variant="light" color="brand">
                            See the ventures
                        </Button>
                    </Group>
                </Stack>
            </Stack>
        </Container>
    );
}

export default Leadership;
